import { Component } from '@angular/core';

/**
 * Editors choice component having listing card, detail page and routes init.
 */
@Component({
  selector: 'app-editor-choice',
  templateUrl: './editor-choice.component.html',
  styleUrls: ['./editor-choice.component.scss']
})
export class EditorChoiceComponent { }
